module.exports = __webpack_public_path__ + "img/violet-4.f549c602.png";